import { render, staticRenderFns } from "./SuspiciousVariations.vue?vue&type=template&id=6f49c820&"
import script from "./SuspiciousVariations.vue?vue&type=script&lang=js&"
export * from "./SuspiciousVariations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports